export default {
    'name': 'fire',
    'width': '34',
    'height': '34',
    'viewBox': '0 0 34 34',
    'data': '<path d=\'M10 19.835C10 23.5205 13.1336 26 17 26C20.8664 26 24 23.5205 24 19.835C24 15.227 18.3343 13.9265 18.2383 8C15.4838 8.9675 12.5119 13.283 13.7249 18.377C12.613 17.927 12.0014 16.532 12.1076 14.975C10.3487 16.4465 10 18.8 10 19.835Z\' fill=\'url(#paint0_linear_11946_3431)\'/><defs><linearGradient id=\'paint0_linear_11946_3431\' x1=\'17\' y1=\'8\' x2=\'17\' y2=\'21.5\' gradientUnits=\'userSpaceOnUse\'><stop stop-color=\'#D99733\'/><stop offset=\'1\' stop-color=\'#CF231A\'/></linearGradient></defs>'
}
